// extracted by mini-css-extract-plugin
export default {"indicatorMain":"Indicator_indicatorMain__+-VUY","indicatorTab":"Indicator_indicatorTab__t1CHb","active":"Indicator_active__DKLyV","fill":"Indicator_fill__AbEr3"};